import { NETWORK, AREA_TYPE } from "./index";

export const STATIC_DOMAIN = {
    [NETWORK.opdev]: 'https://op-assets.ncsoft.com',
    [NETWORK.sb]: 'https://assets.sb.plaync.com',
    [NETWORK.rc]: 'https://rc-assets.playnccdn.com',
    [NETWORK.stage]: 'https://stage-assets.playnccdn.com', // this.__env는 stage -> live로 봄
    [NETWORK.live]: 'https://assets.playnccdn.com',
};

export const PLAYNC_DOMAIN = {
    [NETWORK.opdev]: 'https://www.sb.plaync.com',
    [NETWORK.sb]: 'https://www.sb.plaync.com',
    [NETWORK.rc]: 'https://rc-www.plaync.com',
    [NETWORK.live]: 'https://www.plaync.com'
};

export const NCT_STATIC_DOMAIN = {
    [NETWORK.opdev]: 'https://rc-image-cdn.plaync.com.tw/nct',
    [NETWORK.sb]: 'https://rc-image-cdn.plaync.com.tw/nct',
    [NETWORK.rc]: 'https://rc-image-cdn.plaync.com.tw/nct',
    [NETWORK.stage]: 'https://image-cdn.plaync.com.tw/nct',
    [NETWORK.live]: 'https://image-cdn.plaync.com.tw/nct',
};

export const NCJ_STATIC_DOMAIN = {
    [NETWORK.opdev]: 'https://ncjapan2.nefficient.jp/ncjapan/wstatic_rc/ncj',
    [NETWORK.sb]: 'https://ncjapan2.nefficient.jp/ncjapan/wstatic_rc/ncj',
    [NETWORK.rc]: 'https://ncjapan2.nefficient.jp/ncjapan/wstatic_rc/ncj',
    [NETWORK.stage]: 'https://ncjapan2.nefficient.jp/ncjapan/wstatic_live/ncj', // this.__env는 stage -> live로 봄
    [NETWORK.live]: 'https://ncjapan2.nefficient.jp/ncjapan/wstatic_live/ncj',
};

export const STATIC_DOMAIN_MAP = {
    [AREA_TYPE.NCK]: STATIC_DOMAIN,
    [AREA_TYPE.NCT]: STATIC_DOMAIN,
    [AREA_TYPE.NCJ]: NCJ_STATIC_DOMAIN
};

export const NSHOP_COUPON_DOMAIN = {
    [NETWORK.opdev]: 'http://op.coupon.plaync.com',
    [NETWORK.sb]: 'https://sb-coupon.plaync.com',
    [NETWORK.rc]: 'https://rc-coupon.plaync.com',
    [NETWORK.stage]: 'https://coupon.plaync.com',
    [NETWORK.live]: 'https://coupon.plaync.com',
};